import { Injectable } from '@angular/core';
import { ICardItem } from '@core/interfaces/card/card-item-interface';
import { ICardSource } from '@core/interfaces/card/card-source.interface';
import { IListResult } from '@core/interfaces/list-result/list-result.interface';
import { CardItem } from '@core/models/card/card-item.model';
import { ListResult } from '@core/models/list-result/list-result.model';
import { AppError } from '@interticket/core';
import { Observable, throwError } from 'rxjs';
import { catchError, concatMap, delay, map, take } from 'rxjs/operators';
import { CardCartItem } from '../../models/card/card-cart-item.model';
import { Cart } from '../../models/cart/cart.model';
import { CartService } from '../cart/cart.service';

@Injectable()
export class CardService {

  constructor(
    private cardSourceService: ICardSource,
    private cartService: CartService
  ) { }

  getList(): Observable<ListResult<ICardItem, CardItem>> {
    return this.cardSourceService.getList()
      .pipe(
        take(1),
        map((iListResult: IListResult<ICardItem>) => new ListResult<ICardItem, CardItem>(iListResult, CardItem))
      );
  }

  addToCart(item: CardCartItem): Observable<Cart> {
    return this.cardSourceService.addToCart(item)
      .pipe(
        delay(1000),
        catchError((error: AppError) => {
          this.cartService.getCart();
          return throwError(error);
        }),
        concatMap(() => this.cartService.getCart())
      );
  }

}
